import { Button } from "@material-tailwind/react";
import {
  Backdrop,
  Box,
  Fade,
  FormControlLabel,
  FormGroup,
  Modal,
  Switch,
} from "@mui/material";
import React from "react";
import { IoClose } from "react-icons/io5";

function ModifyTablePerm(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: "40px",
    outline: "none",
    borderRadius: "35px",
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        // onClose={props.onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-4xl text-black">
                Modify Permissions
              </p>
              <IoClose
                className="cursor-pointer border border-[#BDBDBD] rounded-full absolute right-6 top-8 text-[#BDBDBD]"
                onClick={props.onClose}
              />
            </div>
            <form
              onSubmit={props.handleUpdatePerm}
              className="mt-3 w-[300px] sm:w-[400px] flex flex-col gap-3"
            >
              <FormGroup>
                <div className="flex justify-between items-center">
                  <p className="font-semibold">Auto changeover report</p>
                  <FormControlLabel
                    control={<Switch />}
                    checked={props.modifyTableToggle?.chngovr_report === 1}
                    onChange={(e) =>
                      props.setModifyTableToggle({
                        ...props.modifyTableToggle,
                        chngovr_report: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="font-semibold">Weighing scale report</p>
                  <FormControlLabel
                    control={<Switch />}
                    checked={props.modifyTableToggle?.ws_report === 1}
                    onChange={(e) =>
                      props.setModifyTableToggle({
                        ...props.modifyTableToggle,
                        ws_report: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </div>
                <div className="flex justify-between items-center mt-2">
                  <p className="font-semibold">Burner running report</p>
                  <FormControlLabel
                    control={<Switch />}
                    checked={props.modifyTableToggle?.br_report === 1}
                    onChange={(e) =>
                      props.setModifyTableToggle({
                        ...props.modifyTableToggle,
                        br_report: e.target.checked ? 1 : 0,
                      })
                    }
                  />
                </div>
              </FormGroup>

              <div className="flex justify-end items-center">
                <Button
                  type="submit"
                  disabled={props.loading?.btn}
                  className="mt-2 rounded-xl bg-[#03438D] px-7 py-3 tracking-widest font-poppins font-light text-md outline-none"
                >
                  {props.loading?.btn ? "Loading..." : "Save"}
                </Button>
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default ModifyTablePerm;
